// extracted by mini-css-extract-plugin
module.exports = {"skespan":"skeleton_skespan__f9D2J","skecontainer":"skeleton_skecontainer__sbIpz"};